function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 891;


//////////////////
// WEBPACK FOOTER
// ./~/yamljs/lib
// module id = 891
// module chunks = 0 1 5